import { LoadingButton } from '@mui/lab';
import { Box, Divider, Stack, Typography } from '@mui/material';
import OperationProductCard from 'components/shared/operation/OperationProductCard/OperationProductCard';

const LOCATION_FIELDS = [
  { key: 'sectionDisplay', label: 'طبقه' },
  { key: 'areaDisplay', label: 'ناحیه' },
];

const CartProductCard = ({
  product,
  canMutate,
  actionLoading,
  onConfirmMission,
}) => {
  const canConfirm = canMutate && product.status === 'WaitForCheck';
  const locationLine = [
    product.shelfDisplay,
    product.partDisplay,
    product.cellDisplay,
  ]
    .filter(Boolean)
    .join(' - ');

  return (
    <OperationProductCard
      product={product}
      canMutate={canConfirm}
      onAction={() => onConfirmMission?.(product.guid)}
      actionDisabled={actionLoading}
    >
      {LOCATION_FIELDS.filter(field => product[field.key]).map(field => (
        <Box
          key={field.key}
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <Typography variant="body2" color="text.secondary">
            {field.label}
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {product[field.key]}
          </Typography>
        </Box>
      ))}
      {locationLine ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            موقعیت
          </Typography>
          <Typography variant="body2" fontWeight={600}>
            {locationLine}
          </Typography>
        </Box>
      ) : null}
    </OperationProductCard>
  );
};

export const ShoppingCartDetail = ({
  cart,
  products = [],
  detailLoading = false,
  canMutate = false,
  actionLoading = false,
  onConfirmMission,
  onConfirmAllMissions,
}) => {
  if (detailLoading) {
    return (
      <Typography color="text.secondary" textAlign="center" py={4}>
        در حال بارگذاری محصولات سبد...
      </Typography>
    );
  }

  const cartProducts =
    products.length > 0 ? products : cart?.productPackagingList ?? [];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
      >
        <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
          {cart?.agentName ? (
            <>
              <Typography variant="body2" color="text.secondary">
                PDA
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {cart.agentName}
              </Typography>
              <Divider orientation="vertical" flexItem />
            </>
          ) : null}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="body2" color="text.secondary" fontWeight={600}>
              {cartProducts.length}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              محصول
            </Typography>
          </Box>
        </Stack>

        {canMutate && cartProducts.length > 0 ? (
          <LoadingButton
            size="small"
            variant="contained"
            color="success"
            loading={actionLoading}
            onClick={() => onConfirmAllMissions?.(cart.guid)}
          >
            تأیید همه مأموریت‌ها
          </LoadingButton>
        ) : null}
      </Stack>

      {cartProducts.length === 0 ? (
        <Box
          sx={{
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography color="text.secondary">
            محصولی در این سبد نیست.
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
              xl: 'repeat(4, 1fr)',
            },
            gap: 2,
          }}
        >
          {cartProducts.map(product => (
            <CartProductCard
              key={product.guid}
              product={product}
              canMutate={canMutate}
              actionLoading={actionLoading}
              onConfirmMission={onConfirmMission}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
